<template>
  <v-card width="100%" height="100%" outlined>
    <v-toolbar color="accent" dark class="title" flat>
      <v-icon left>fas fa-chevron-right</v-icon>
      Mount Forms DB Login
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col cols="12" md="6" offset-md="3">
          <v-card outlined>
            <v-toolbar flat dense color="secondary" dark class="title">Enter your login information:</v-toolbar>
            <v-row class="ma-2">
              <v-col cols="10" offset="1">
                <v-text-field
                  outlined
                  color="secondary"
                  label="Admin Email:"
                  v-model="user.email"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-2">
              <v-col cols="10" offset="1">
                <v-text-field
                  outlined
                  color="secondary"
                  label="Password:"
                  v-model="user.pass"
                  type="password"

                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="ma-2">
              <v-col cols="6" offset="3" class="text-center text-sm-right">
                <v-btn color="secondary" block outlined @click="login()">
                  <v-icon left small>fas fa-sign-in-alt</v-icon>
                  Login
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  created(){
    this.$store.dispatch('getUsers')
  },
  data(){
    return {
      user    : {
        email : "",
        pass  : ""
      }
    }
  },
  methods: {
    login(){
      this.$store.dispatch('login', this.user)
    }
  }
}
</script>
